import { useNavigate } from 'react-router-dom';

import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import { useMenuName } from 'hb-react/shared/hooks/useMenuName';

const NewsNotFound = () => {
  const navigate = useNavigate();
  const menuName = useMenuName('news', __('News'));

  return (
    <SimpleCard
      faIconProps={{
        iconName: 'message-exclamation',
      }}
      title={s__('News|News not found')}
      description={s__('News|Sorry, this news was not found')}
      buttonProps={{
        children: s__('News|Go to %{name}').i__({
          name: menuName,
        }),
        onClick: () => navigate('..'),
      }}
    />
  );
};

export default NewsNotFound;
